export const LOCATION = {
  DASHBOARDS: '/dashboards',
  SEGMENTS: '/segments',
  FUNNELS: '/funnels',
  RETENTION: '/retention',
  ADVANCED_RETENTION: '/advanced/retention',
  USAGE: '/usage',
  REVENUE: '/revenue',
  EVENTS: '/events',
  USERS: '/users',
  ADVANCED_EVENTS: '/advanced/events',
  ADVANCED_FUNNEL: '/advanced/funnel',
  ADVANCED_MAPPING: '/advanced/mapping',
  FIELDS: '/fields',
  MAPPING: '/mapping',
  AUTHORIZATION: '/authorization',
  LOGIN: '/login',
  LABELS: '/labels',
  UNKNOWN: '/unknown',
  ERROR: '/error',
  INDEXES: '/indexes',
  REPORTS: '/reports',
};

export const getPath = (location) => {
  return Object.values(LOCATION).find((value) => !!location.match(`^/[^/]+${value}`));
};
